import { jsx as _jsx } from "react/jsx-runtime";
const DisabledEDS = () => {
    return (_jsx("div", { className: "text-center", children: _jsx("h2", { children: "Sorry this module is currently disabled." }) }));
};
export default DisabledEDS;
